import { ConsentAcceptanceSchema, type ConsentAcceptance } from "./schemas";

/** Analysis acceptance must come from the supplied record, never a fallback. */
export function requireAnalysisConsent(input: unknown): ConsentAcceptance {
  const parsed = ConsentAcceptanceSchema.safeParse(input);
  if (!parsed.success || !parsed.data.analysisConsent) {
    throw Object.assign(new Error("consent_required: explicit valid analysis consent is required."), { status: 403, code: "consent_required" });
  }
  return parsed.data;
}

export function consentSensitivity(consent: ConsentAcceptance): "standard" | "rights_unclear" {
  return consent.rightsAttestation && consent.aiDisclosureAcknowledged ? "standard" : "rights_unclear";
}
